import { Text } from 'braid-design-system';
import { useEffect, useState } from 'react';

interface CountdownProps {
  endTime: Date;
}

export const Countdown = ({ endTime }: CountdownProps) => {
  const [seconds, setSeconds] = useState(
    Math.floor(endTime.getTime() / 1000) - Math.floor(Date.now() / 1000),
  );

  useEffect(() => {
    if (seconds <= 0) {
      return;
    }

    const interval = setInterval(() => {
      setSeconds(seconds - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [seconds]);

  return <Text weight="strong">{formatRemainingSeconds(seconds)}</Text>;
};

const formatRemainingSeconds = (remainingSeconds: number) => {
  if (remainingSeconds <= 0) {
    return '00:00:00';
  }

  const hours = Math.floor(remainingSeconds / 3600);
  const minutes = Math.floor((remainingSeconds % 3600) / 60);
  const seconds = remainingSeconds % 60;

  return [hours, minutes, seconds]
    .map((unit) => String(unit).padStart(2, '0'))
    .join(':');
};
